export const PERSON_TAB_KEYS = {
  EDIT_PERSON: 'editPerson',
  ADDRESSES: 'addresses',
  ASSOCIATE: 'associate',
  ATTACHMENTS: 'attachments',
  BULLETINS: 'bulletins',
  CONTACT_METHODS: 'contactMethods',
  CREDENTIAL: 'credential',
  DNA_SAMPLES: 'dnaSamples',
  EMPLOYMENT: 'employment',
  FEATURES: 'features',
  NAMES: 'names',
  PHOTO: 'photo',
  RELATED_RECORDS: 'relatedRecords',
  SMT_RECORDS: 'smtRecords',
  SOPS: 'sops',
  TAGS: 'tags',
  VEHICLE_REGISTRATIONS: 'vehicleRegistrations',
};

export const PERSON_TABS = [
  { key: PERSON_TAB_KEYS.EDIT_PERSON, label: 'Edit Person' },
  { key: PERSON_TAB_KEYS.ADDRESSES, label: 'Addresses' },
  { key: PERSON_TAB_KEYS.ASSOCIATE, label: 'Associate' },
  { key: PERSON_TAB_KEYS.ATTACHMENTS, label: 'Attachments' },
  { key: PERSON_TAB_KEYS.BULLETINS, label: 'Bulletins' },
  { key: PERSON_TAB_KEYS.CONTACT_METHODS, label: 'Contact Methods' },
  { key: PERSON_TAB_KEYS.CREDENTIAL, label: 'Credential' },
  { key: PERSON_TAB_KEYS.DNA_SAMPLES, label: 'DNA Samples' },
  { key: PERSON_TAB_KEYS.EMPLOYMENT, label: 'Employment' },
  { key: PERSON_TAB_KEYS.FEATURES, label: 'Features' },
  { key: PERSON_TAB_KEYS.NAMES, label: 'Names' },
  { key: PERSON_TAB_KEYS.PHOTO, label: 'Photo' },
  { key: PERSON_TAB_KEYS.RELATED_RECORDS, label: 'Related Records' },
  { key: PERSON_TAB_KEYS.SMT_RECORDS, label: 'SMT Records' },
  { key: PERSON_TAB_KEYS.SOPS, label: 'SOPs' },
  { key: PERSON_TAB_KEYS.TAGS, label: 'Tags' },
  { key: PERSON_TAB_KEYS.VEHICLE_REGISTRATIONS, label: 'Vehicle Registrations' },
];
